<ng-container class="spread" *ngIf="(view$ | async) as view">
	<p-toolbar>
		<ng-container *ngIf="showTitle">
			<div class="p-toolbar-group-start">
				<h3 class="list-title" [innerHTML]="title"></h3>
			</div>
		</ng-container>
		<div class="p-toolbar-group-end">
			<ng-container *ngFor="let action of getListActions(view.actions)">
				<ng-container ntapNewListItemProvider>
					<ntap-dynamic [compId]="getActionComponentId(action)" [inputParam]="action"></ntap-dynamic>
				</ng-container>
			</ng-container>
		</div>
	</p-toolbar>
</ng-container>